import { Imatge } from '@portal-internet/components';
import { getStorageValue, setStorageValue } from '@portal-internet/core';
import Boto from 'components/ui/Boto';
import { useProducte } from 'hooks/3cat/useProducte';
import { useUser } from 'hooks/useUser';
import __isUndefined from 'lodash/isUndefined';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import styles from './onboardingreviu.module.scss';

export default function Component(props) {
    const { layout } = props;
    const [showOnboarding, setShowOnboarding] = useState(false);
    const [showedToday, setShowedToday] = useState(true);
    const [cookieChecked, setCookieChecked] = useState(false);
    const timeoutShowOnboarding = useRef();
    const { isWebviewActive } = useProducte();

    const router = useRouter();
    const refOnboarding = useRef();
    const isTest = typeof window !== 'undefined' && window.isCypressTest;
    const { isAuthenticated } = useUser();
    const nomCookie = 'onboarding';
    const estructuraCookieDefault = {
        day: '2020/01/01'
    };

    const isEmbedOrPopup = router.asPath.includes('/popup/') || router.asPath.includes('/embed/');

    const isAvisActive = () => {
        return layout?.structure?.find((item) => item.name === 'ModulAvis')?.finalProps?.item?.length > 0;
    };

    const saveOnStorage = (values) => {
        setStorageValue(nomCookie, values, {
            path: '/',
            domain: '.3cat.cat',
            expires: 1
        });
    };
    const initializeValues = (data) => {
        let response;
        if (__isUndefined(data)) {
            response = estructuraCookieDefault;
        } else {
            response = data;
        }
        return response;
    };

    const fetchDayCookieData = async () => {
        const data = await getStorageValue(nomCookie);
        let value = initializeValues(data);
        let todayDate = getToday();
        if (value.day !== todayDate) {
            value.day = todayDate;
            setShowedToday(false);
            saveOnStorage(value);
        }
        setCookieChecked(true);
    };

    const tancaOnboarding = () => {
        netejeUrlOnboarding();
        setShowOnboarding(false);
        setShowedToday(true);
        document.getElementById('__mainContent').removeAttribute('inert');
    };

    const netejeUrlOnboarding = () => {
        let url = router.asPath?.split('#')[0];
        router.push(url, undefined, { scroll: false });
    };

    const getToday = () => {
        const dateObj = new Date();
        const month = dateObj.getUTCMonth() + 1;
        const day = dateObj.getUTCDate();
        const year = dateObj.getUTCFullYear();
        return year + '/' + month + '/' + day;
    };

    useEffect(() => {
        fetchDayCookieData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!__isUndefined(refOnboarding.current) && showOnboarding === true && !isTest && !showedToday) {
            refOnboarding.current.focus();
            document.getElementById('__mainContent').setAttribute('inert', true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refOnboarding.current]);

    useEffect(() => {
        if (!isAuthenticated && isAuthenticated !== null && !isWebviewActive && cookieChecked) {
            timeoutShowOnboarding.current = setTimeout(() => {
                setShowOnboarding(true);
            }, 3500);
        }
        return () => clearTimeout(timeoutShowOnboarding.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated, cookieChecked]);

    const contentOnBoarding = (tipus) => {
        return (
            <div
                className={styles.onBoardingReviu}
                {...{
                    'role': 'dialog',
                    'aria-modal': 'true',
                    'aria-labelledby': 'onboarding-titol'
                }}
            >
                <div className={styles.mask + ' ' + styles.onboarding} onClick={() => tancaOnboarding()} ref={refOnboarding}>
                    <div className={styles.wrapper} onClick={(e) => e.stopPropagation()}>
                        <div className={styles.textWrapper}>
                            <h2 className={styles.titol}>
                                <Imatge src='/_resources/logos/reviu25.svg' width={280} height={64} alt='REVIU 25' />
                            </h2>
                            <p className={styles.entradeta}>Un recull del teu any a 3Cat</p>
                            <Boto
                                text='Ves al teu reviu'
                                tag='a'
                                link='https://reviu.3cat.cat/?int=DW_3CAT_WEB_C107_F1_modal_'
                                className={styles.boto}
                                dataTestId='onboarding-inicia-sessio-button'
                            />
                            <button className={styles.tanca} onClick={() => tancaOnboarding()}>
                                Continua navegant
                            </button>
                        </div>
                        <div className={styles.imatgeWrapper}>
                            <Imatge
                                src='/_resources/imatges/mobil_top5.svg'
                                width={363}
                                height={510}
                                alt='El que has seguit i el que ha connectat amb tothom'
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    if (showOnboarding && !isTest && !showedToday && !isEmbedOrPopup && !isAvisActive()) {
        return contentOnBoarding();
    } else {
        return null;
    }
}
